import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol viewBox=\"0 0 500 500\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"minus\">\n<path d=\"M35.7143 239.285C29.7969 239.285 25 244.082 25 250C25 255.917 29.7969 260.714 35.7143 260.714H464.286C470.203 260.714 475 255.917 475 250C475 244.082 470.203 239.285 464.286 239.285L35.7143 239.285Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol